import React from 'react'
import { Link } from 'react-router-dom'
import Card from '~/components/Card'
import {
    Container
} from './styles'

export default function () {
    return (
        <Container>
            <Card>
                <div className="flex flex-col gap-8">
                    <h1>Faça sua associação</h1>

                    <div className="mx-2">
                        O SINDMEPA está sempre ao seu lado, defendendo seus direitos. Junte-se a nós e fortaleça a luta em favor da categoria médica!
                    </div>

                    <Link to="/associacao" className="button white" style={{ color: '#424242', fontWeight: 500 }}>
                        Associe-se aqui
                    </Link>
                </div>
            </Card>
        </Container>
    )
}
